/**
 * @generated SignedSource<<77b0386596c3d5c95cb0ba8ec74252d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BillingFrequency = "MONTHLY" | "ONE_TIME" | "YEARLY";
export type PackageBillingType = "ONE_TIME" | "SUBSCRIPTION";
import { FragmentRefs } from "relay-runtime";
export type PackageItem_memberPackage$data = {
  readonly cancelledOn: string | null | undefined;
  readonly endsOn: string | null | undefined;
  readonly id: string;
  readonly package: {
    readonly __typename: string;
    readonly billingOptions: ReadonlyArray<{
      readonly billingCharges: ReadonlyArray<{
        readonly frequency: BillingFrequency;
        readonly squareVariation: {
          readonly amount: number | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined> | null | undefined;
    readonly billingType: PackageBillingType;
    readonly " $fragmentSpreads": FragmentRefs<"usePackageDisplayName_package">;
  };
  readonly startsOn: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"usePackageMonthlyPrice_memberPackage" | "usePackageNeedsAttention_memberPackage">;
  readonly " $fragmentType": "PackageItem_memberPackage";
};
export type PackageItem_memberPackage$key = {
  readonly " $data"?: PackageItem_memberPackage$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageItem_memberPackage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageItem_memberPackage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePackageMonthlyPrice_memberPackage"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePackageNeedsAttention_memberPackage"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "package",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "usePackageDisplayName_package"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "billingType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingOption",
          "kind": "LinkedField",
          "name": "billingOptions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "BillingCharge",
              "kind": "LinkedField",
              "name": "billingCharges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "frequency",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SquareItemVariation",
                  "kind": "LinkedField",
                  "name": "squareVariation",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "amount",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cancelledOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startsOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endsOn",
      "storageKey": null
    }
  ],
  "type": "MemberPackage",
  "abstractKey": null
};

(node as any).hash = "67069c25242ee84a89d517d44721fb57";

export default node;
